import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { activityTracker } from '../services/ActivityTracker'
import clarityService from '../services/ClarityService'

export const useRouteTracking = (isAuthenticated) => {
  const location = useLocation()
  const previousPath = useRef(null)
  const isInitialMount = useRef(true)

  useEffect(() => {
    const currentPath = location.pathname + location.search

    // Skip initial mount - ActivityTracker.initialize() handles first page view
    if (isInitialMount.current) {
      isInitialMount.current = false
      previousPath.current = currentPath

      // For non-authenticated users, track with Clarity
      if (!isAuthenticated) {
        clarityService.trackPageView(currentPath, {
          authenticated: false,
          isInitialLoad: true,
        })
      }
      return
    }

    // Skip if it's the same page
    if (previousPath.current === currentPath) return

    if (isAuthenticated) {
      // Authenticated: use ActivityTracker (which also calls Clarity)
      activityTracker.handleRouteChange(currentPath)
    } else {
      // Not authenticated: use Clarity directly
      clarityService.trackPageView(currentPath, {
        authenticated: false,
        isRouteChange: true,
      })
    }

    // Update previous path
    previousPath.current = currentPath
  }, [location.pathname, location.search, isAuthenticated])
}
